import Fnds from './actions/fnds';
import Organizations from './actions/organizations';

const actions = {
    ...Fnds,
    ...Organizations,
};

export default actions;
